import {
    Categorie_pieces,
    Garant,
    GarantMonoBloc,
    Section_Locataire,
    Type_garantie,
    DocumentType,
    GarantPhysique,
    FileType,
} from "shared/types/types";

export const makeEmptyLocataire = (): Section_Locataire => ({ // Créer un locataire vide
    [Categorie_pieces.IDENTITE]: [],
    [Categorie_pieces.DOMICILE]: [],
    [Categorie_pieces.SITUATION_PRO]: [],
    [Categorie_pieces.RESSOURCES]: [],
});

export const uuid = () => Math.random().toString(36).slice(2,10); // Pour créer un id aléatoire

export const ordreCategorie: Categorie_pieces[] = [ //Ordre d'affichage des catégories
    Categorie_pieces.IDENTITE,
    Categorie_pieces.DOMICILE,
    Categorie_pieces.SITUATION_PRO,
    Categorie_pieces.RESSOURCES,
]

const toPercent = (ratio: number) => Math.round(Math.max(0, Math.min(1, ratio)) * 100);

const countCompletedFromFlatDocs = (documents: FileType[]): number => {
    if (!Array.isArray(documents) || documents.length === 0) return 0;
    return ordreCategorie.filter(cat => documents.some(d => d.categoriePieces === cat)).length;
};

const countCompletedFromSection = (section: Section_Locataire): number => {
    if (!section) return 0;
    return ordreCategorie.filter(cat => (section[cat] ?? []).length > 0).length;
};



/* Calcul de la complétude de la section Locataire et de la section Garants */
export function calculCompletudeLocataire(input: FileType[] | Section_Locataire): number {

    const completed =
        Array.isArray(input)
        ? countCompletedFromFlatDocs(input as FileType[])
        : countCompletedFromSection(input as Section_Locataire);

    return toPercent(completed / ordreCategorie.length);
}

export const calculCompletudeGarant = (garant: Garant): number => {
    if (garant.type === Type_garantie.PHYSIQUE) {
        const g = garant as GarantPhysique;
        return calculCompletudeLocataire(g.docs);
    }

    const m = garant as GarantMonoBloc;
    return (m.certificate && m.certificate.length > 0) ? 100 : 0;
};

export const calculCompletudeSectionGarant = (garants: Garant[]): number => {
    if (!Array.isArray(garants) || garants.length === 0) return 0;
    const total = garants.reduce((sum, g) => sum + calculCompletudeGarant(g), 0);
    return Math.round(total / garants.length);
};

export const calculCompletudeDossierOverall = (locataire: FileType[] | Section_Locataire, garants: Garant[]): number => {
    const cLoc = calculCompletudeLocataire(locataire);
    // const cGar = calculCompletudeSectionGarant(garants);
    return Math.round(cLoc);
};

